import React, { useState } from 'react';
import './Portfolio.css';

/**
 * Composant Portfolio - Réalisations clients
 * Utilise le framework BAB (Before/After/Bridge) du skill B2B Copywriting
 */

const Portfolio = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  // Projets utilisant le framework BAB (Before/After/Bridge)
  const projects = [
    {
      id: 1,
      title: "Site E-commerce BioCosmétiques Lille",
      category: "E-commerce",
      client: "PME Cosmétiques Bio (3 employés)",
      year: "2025",
      thumbnail: "🛍️", // Placeholder - à remplacer par vraie image
      images: [
        "/portfolio/1-ecommerce/hero.png",
        "/portfolio/1-ecommerce/preview-1.png",
        "/portfolio/1-ecommerce/preview-2.png"
      ],
      pdfUrl: "/portfolio/1-ecommerce/case-study.pdf",
      technologies: ["React", "Shopify", "Stripe"],

      // Framework BAB
      before: "Site vitrine statique peu visité. Ventes uniquement en boutique physique, ca limité à 15km autour. CA mensuel : 2 000€",
      after: "Boutique en ligne performante, livraison nationale. CA mensuel passé de 2 000€ à 8 000€ (+300%) en 4 mois",
      bridge: "Refonte complète avec focus SEO local, optimisation fiches produits, tunnel de conversion simplifié et formation de l'équipe",

      results: [
        { metric: "+300%", label: "CA mensuel (2k€ → 8k€)" },
        { metric: "45%", label: "Taux de conversion" },
        { metric: "< 2s", label: "Temps de chargement" }
      ],

      testimonial: {
        quote: "Notre CA a quadruplé en 4 mois. L'accompagnement d'Antho sur le SEO local et l'optimisation des fiches produits a fait toute la différence.",
        author: "Marie Dubois, Gérante"
      }
    },

    {
      id: 2,
      title: "Infrastructure Cloud - Cabinet Comptable",
      category: "Cloud Infrastructure",
      client: "Cabinet comptable (12 employés)",
      year: "2023",
      thumbnail: "☁️",
      images: [
        "/portfolio/4-dashboard-cloud/hero.png",
        "/portfolio/4-dashboard-cloud/preview-1.png",
        "/portfolio/4-dashboard-cloud/preview-2.png"
      ],
      pdfUrl: "/portfolio/4-dashboard-cloud/case-study.pdf",
      technologies: ["AWS", "Docker", "PostgreSQL"],

      before: "Serveurs physiques vieillissants, pannes fréquentes (2-3x/mois), sauvegardes manuelles aléatoires. Coûts IT : 2 500€/mois",
      after: "Infrastructure cloud haute disponibilité, 0 panne en 12 mois, sauvegardes automatiques quotidiennes. Coûts : 1 500€/mois (-40%)",
      bridge: "Migration progressive sur AWS avec zéro interruption, formation des équipes, mise en place monitoring 24/7 et plan de reprise d'activité",

      results: [
        { metric: "-40%", label: "Coûts IT (2,5k€ → 1,5k€)" },
        { metric: "99.9%", label: "Uptime garanti" },
        { metric: "0", label: "Pannes en 12 mois" }
      ],

      testimonial: {
        quote: "Plus aucune panne depuis la migration. Nous avons économisé 12 000€ la première année tout en gagnant en fiabilité.",
        author: "Jean Martin, Directeur IT"
      }
    },

    {
      id: 3,
      title: "Application Web Intranet - PME Industrielle",
      category: "Développement Web",
      client: "PME Industrielle (45 employés)",
      year: "2025",
      thumbnail: "💻",
      images: [
        "/portfolio/3-intranet-pme/hero.png",
        "/portfolio/3-intranet-pme/preview-1.png",
        "/portfolio/3-intranet-pme/preview-2.png"
      ],
      pdfUrl: "/portfolio/3-intranet-pme/case-study.pdf",
      technologies: ["React", "Node.js", "MongoDB"],

      before: "Gestion sur Excel et papier, erreurs fréquentes de saisie, temps de traitement long (2-3 jours par commande), pas de visibilité temps réel",
      after: "Application web centralisée, saisie automatisée avec validation, traitement instantané, tableau de bord temps réel. Gain de 15h/semaine",
      bridge: "Développement d'une interface intuitive, import automatique des données Excel historiques, formation sur 2 jours, support pendant 3 mois",

      results: [
        { metric: "15h/semaine", label: "Temps gagné" },
        { metric: "90%", label: "Réduction des erreurs" },
        { metric: "8 semaines", label: "ROI atteint" }
      ],

      testimonial: {
        quote: "L'équipe administrative a gagné 15h par semaine. Le retour sur investissement a été atteint en 2 mois.",
        author: "Sophie Durand, Responsable Administrative"
      }
    },

    {
      id: 4,
      title: "Chatbot IA - Service Client E-commerce",
      category: "Intelligence Artificielle",
      client: "E-commerce Mode (8 employés)",
      year: "2025",
      thumbnail: "🤖",
      images: [
        "/portfolio/2-chatbot-ia/hero.png",
        "/portfolio/2-chatbot-ia/preview-1.png",
        "/portfolio/2-chatbot-ia/preview-2.png"
      ],
      pdfUrl: "/portfolio/2-chatbot-ia/case-study.pdf",
      technologies: ["OpenAI GPT", "Python", "React"],

      before: "Service client débordé, temps de réponse moyen 12h, questions répétitives (80% identiques), satisfaction client 65%",
      after: "Chatbot IA traite 75% des demandes instantanément, temps de réponse < 1min, satisfaction client 92%, équipe concentrée sur cas complexes",
      bridge: "Analyse de 2000+ conversations clients, entraînement IA sur FAQ spécifiques, intégration progressive avec escalade vers humains",

      results: [
        { metric: "75%", label: "Demandes automatisées" },
        { metric: "92%", label: "Satisfaction client" },
        { metric: "< 1min", label: "Temps de réponse moyen" }
      ],

      testimonial: {
        quote: "Le chatbot gère 3 clients sur 4. Notre équipe peut enfin se concentrer sur les demandes complexes. Game changer !",
        author: "Thomas Leroy, Responsable Client"
      }
    },

    {
      id: 5,
      title: "Audit Cybersécurité - Startup FinTech",
      category: "Cybersécurité",
      client: "Startup FinTech (15 employés)",
      year: "2023",
      thumbnail: "🔒",
      images: [
        "/portfolio/5-audit-cybersecurite/hero.png",
        "/portfolio/5-audit-cybersecurite/preview-1.png",
        "/portfolio/5-audit-cybersecurite/preview-2.png"
      ],
      pdfUrl: "/portfolio/5-audit-cybersecurite/case-study.pdf",
      technologies: ["Penetration Testing", "OWASP", "Security Audit"],

      before: "Aucun audit de sécurité, mots de passe faibles, données sensibles non chiffrées, 12 vulnérabilités critiques identifiées lors du test",
      after: "100% des vulnérabilités critiques corrigées, chiffrement end-to-end, authentification 2FA, conformité RGPD. Score sécurité : 95/100",
      bridge: "Audit complet avec tests d'intrusion, rapport détaillé avec priorisation, accompagnement sur la correction de chaque faille, suivi mensuel",

      results: [
        { metric: "12 → 0", label: "Vulnérabilités critiques" },
        { metric: "95/100", label: "Score de sécurité" },
        { metric: "100%", label: "Conformité RGPD" }
      ],

      testimonial: {
        quote: "L'audit a révélé 12 failles critiques dont nous n'avions aucune idée. Tout a été corrigé en 3 semaines. Rassurant !",
        author: "Alexandre Blanc, CTO"
      }
    },

    {
      id: 6,
      title: "Application Mobile - Artisans du Bâtiment",
      category: "Application Mobile",
      client: "Artisan plombier indépendant (Hauts-de-France)",
      year: "2025",
      thumbnail: "📱",
      images: [
        "/portfolio/6-app-mobile-artisans/hero.png",
        "/portfolio/6-app-mobile-artisans/preview-1.png",
        "/portfolio/6-app-mobile-artisans/preview-2.png"
      ],
      pdfUrl: "/portfolio/6-app-mobile-artisans/case-study.pdf",
      technologies: ["React Native", "Expo", "Firebase", "Stripe Connect"],

      before: "Devis papier perdus (15% jamais envoyés), 8h/semaine de travail administratif, délai envoi devis 2-3 jours, 60% des devis sans relance, délai paiement 45 jours",
      after: "App mobile tout-en-un depuis le chantier. Temps admin : 8h → 30min/semaine (-94%), envoi devis : 2 min (-97%), délai paiement : 27 jours (-40%), taux conversion : +25%, CA mensuel : +21%",
      bridge: "Développement React Native + Expo avec signature électronique tactile, génération PDF automatique, paiements Stripe, notifications push. Interface mobile-first optimisée pour usage chantier (gants, soleil). ROI : 211% sur 12 mois",

      results: [
        { metric: "-94%", label: "Temps admin (8h → 30min/semaine)" },
        { metric: "-97%", label: "Temps envoi devis (60min → 2min)" },
        { metric: "+25%", label: "Taux conversion devis (48% → 60%)" }
      ],

      testimonial: {
        quote: "L'app, c'est devenu mon bras droit. Je fais mes devis direct sur place en 2 minutes, le client signe, il reçoit le PDF dans la minute. J'ai récupéré 7 heures par semaine que je peux passer en famille ou prendre des chantiers en plus. Mon CA a augmenté de 20% sans embaucher personne.",
        author: "Marc Durand, Plombier indépendant"
      }
    }
  ];

  return (
    <section id="portfolio" className="py-32 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="absolute top-1/2 left-0 w-[500px] h-[500px] bg-[var(--primary)] rounded-full blur-[150px] opacity-10 pointer-events-none"></div>
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16 fade-in">
          <div className="inline-block mb-4 px-4 py-1 rounded-full border border-[var(--secondary)] bg-[rgba(0,198,255,0.1)] text-[var(--secondary)] text-sm font-bold tracking-widest uppercase">PORTFOLIO & MODÈLES</div>
          <h2 className="text-4xl sm:text-5xl font-bold mb-4 font-['Space_Grotesk'] text-white">
            Inspirez-vous de Nos <span className="text-gradient-electric">Réalisations</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Chaque projet ci-dessous peut servir de <span className="text-[var(--primary)] font-semibold">modèle de départ</span> pour votre propre site.
            <br />
            Sélectionnez un style qui vous plaît, nous l'adaptons à votre image.
          </p>
        </div>

        {/* Grille de projets */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project) => (
            <div
              key={project.id}
              className="glass-panel rounded-3xl p-6 card-reveal cursor-pointer fade-in group hover:border-[var(--primary)] transition-all duration-500"
              onClick={() => setSelectedProject(project)}
            >
              {/* Thumbnail */}
              <div className="w-full h-48 rounded-2xl bg-gradient-to-br from-[var(--primary)]/20 to-[var(--secondary)]/20 flex items-center justify-center text-6xl mb-6 group-hover:scale-105 transition-transform duration-500 shadow-[0_0_30px_rgba(112,0,255,0.15)]">
                {project.thumbnail}
              </div>

              {/* Titre et catégorie */}
              <div className="mb-4">
                <span className="text-[var(--secondary)] text-sm font-bold uppercase tracking-widest">
                  {project.category}
                </span>
                <h3 className="text-xl font-bold text-white mt-2 font-['Space_Grotesk'] group-hover:text-[var(--primary)] transition-colors">
                  {project.title}
                </h3>
                <p className="text-gray-500 text-sm mt-1">{project.client} • {project.year}</p>
              </div>

              {/* Résultats clés */}
              <div className="grid grid-cols-3 gap-2 mb-6">
                {project.results.slice(0, 3).map((result, idx) => (
                  <div key={idx} className="text-center">
                    <div className="text-transparent bg-clip-text bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] font-bold text-lg mb-1">{result.metric}</div>
                    <div className="text-gray-400 text-xs uppercase tracking-wider">{result.label}</div>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <button className="w-full text-[var(--primary)] font-bold py-3 rounded-xl border border-[var(--primary)]/30 hover:bg-[var(--primary)] hover:text-white transition-all uppercase tracking-wider text-sm">
                Voir ce Modèle →
              </button>
            </div>
          ))}
        </div>

        {/* Modal projet détaillé */}
        {selectedProject && (
          <div
            className="fixed inset-0 bg-[#030014]/90 backdrop-blur-xl z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedProject(null)}
          >
            <div
              className="glass-panel rounded-3xl p-8 max-w-3xl w-full max-h-[90vh] overflow-y-auto border-[var(--primary)]/30 shadow-[0_0_100px_rgba(112,0,255,0.2)]"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="flex justify-between items-start mb-8">
                <div>
                  <span className="text-[var(--secondary)] text-sm font-bold uppercase tracking-widest">
                    {selectedProject.category}
                  </span>
                  <h2 className="text-3xl sm:text-4xl font-bold text-white mt-2 font-['Space_Grotesk']">
                    {selectedProject.title}
                  </h2>
                  <p className="text-gray-400 mt-2">{selectedProject.client} • {selectedProject.year}</p>
                </div>
                <button
                  onClick={() => setSelectedProject(null)}
                  className="text-gray-400 hover:text-white text-2xl w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors"
                >
                  ✕
                </button>
              </div>

              {/* Framework BAB */}
              <div className="space-y-6 mb-10">
                {/* BEFORE */}
                <div className="border-l-4 border-red-500/50 pl-6 py-1 bg-red-500/5 rounded-r-xl">
                  <h4 className="text-red-400 font-bold mb-2 uppercase text-xs tracking-wider">❌ Avant</h4>
                  <p className="text-gray-300 leading-relaxed">{selectedProject.before}</p>
                </div>

                {/* AFTER */}
                <div className="border-l-4 border-[var(--success)] pl-6 py-1 bg-[var(--success)]/5 rounded-r-xl">
                  <h4 className="text-[var(--success)] font-bold mb-2 uppercase text-xs tracking-wider">✅ Après</h4>
                  <p className="text-gray-300 leading-relaxed">{selectedProject.after}</p>
                </div>

                {/* BRIDGE */}
                <div className="border-l-4 border-[var(--secondary)] pl-6 py-1 bg-[var(--secondary)]/5 rounded-r-xl">
                  <h4 className="text-[var(--secondary)] font-bold mb-2 uppercase text-xs tracking-wider">🔧 Comment</h4>
                  <p className="text-gray-300 leading-relaxed">{selectedProject.bridge}</p>
                </div>
              </div>

              {/* Résultats */}
              <div className="mb-10">
                <h4 className="text-white font-bold mb-6 font-['Space_Grotesk'] uppercase tracking-wider text-sm">📊 Résultats Mesurables</h4>
                <div className="grid grid-cols-3 gap-4">
                  {selectedProject.results.map((result, idx) => (
                    <div key={idx} className="glass-panel rounded-2xl p-4 text-center bg-[rgba(255,255,255,0.03)]">
                      <div className="text-transparent bg-clip-text bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] font-bold text-2xl mb-2">{result.metric}</div>
                      <div className="text-gray-400 text-xs uppercase tracking-wider font-medium">{result.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Galerie Screenshots */}
              {selectedProject.images && selectedProject.images.length > 0 && (
                <div className="mb-10">
                  <h4 className="text-white font-bold mb-6 font-['Space_Grotesk'] uppercase tracking-wider text-sm">📸 Aperçu du Projet</h4>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {selectedProject.images.map((img, idx) => (
                      <div key={idx} className="rounded-xl overflow-hidden border border-[var(--border-glass)] group">
                        <img
                          src={img}
                          alt={`${selectedProject.title} - Screenshot ${idx + 1}`}
                          className="w-full h-48 object-cover hover:scale-110 transition-transform duration-500"
                          onError={(e) => {
                            e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 300"><rect width="400" height="300" fill="%237000FF20"/><text x="50%" y="50%" text-anchor="middle" fill="%237000FF" font-size="16" font-family="sans-serif">Aperçu à venir</text></svg>';
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Technologies */}
              <div className="mb-10">
                <h4 className="text-white font-bold mb-6 font-['Space_Grotesk'] uppercase tracking-wider text-sm">🛠️ Technologies Utilisées</h4>
                <div className="flex flex-wrap gap-3">
                  {selectedProject.technologies.map((tech, idx) => (
                    <span
                      key={idx}
                      className="px-4 py-2 rounded-full bg-[var(--primary)]/10 border border-[var(--primary)]/30 text-[var(--primary)] text-sm font-medium"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>

              {/* Témoignage */}
              <div className="bg-gradient-to-r from-[var(--primary)]/10 to-[var(--secondary)]/10 rounded-2xl p-8 border border-[var(--primary)]/20 mb-10 relative overflow-hidden">
                <div className="absolute top-0 left-0 text-6xl text-[var(--primary)]/20 font-serif leading-none transform -translate-x-2 -translate-y-4">"</div>
                <p className="text-gray-200 italic mb-4 text-lg relative z-10 font-light">"{selectedProject.testimonial.quote}"</p>
                <p className="text-[var(--secondary)] text-sm font-bold uppercase tracking-wider">— {selectedProject.testimonial.author}</p>
              </div>

              {/* CTA */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                {/* Bouton télécharger PDF Case Study */}
                {selectedProject.pdfUrl && (
                  <a
                    href={selectedProject.pdfUrl}
                    download
                    className="inline-block bg-transparent hover:bg-white/5 text-[var(--primary)] border border-[var(--primary)] px-8 py-4 rounded-xl font-bold transition-all text-center uppercase tracking-wider text-sm"
                    onClick={(e) => {
                      fetch(selectedProject.pdfUrl, { method: 'HEAD' })
                        .catch(() => {
                          e.preventDefault();
                          alert('Le PDF case study sera bientôt disponible !');
                        });
                    }}
                  >
                    📄 Télécharger Case Study
                  </a>
                )}

                {/* Bouton CTA principal */}
                <a
                  href="#contact"
                  className="btn-magnetic inline-block bg-[var(--primary)] hover:bg-[var(--primary-dark)] text-white px-8 py-4 rounded-xl font-bold transition-all text-center uppercase tracking-wider text-sm shadow-lg shadow-purple-500/25"
                  onClick={() => setSelectedProject(null)}
                >
                  Je veux ce Modèle
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Portfolio;
